module.exports = __webpack_public_path__ + "img/oracleoke-black.aaa9e8cf.svg";